import cn from 'classnames';

import Heading from 'components/common/Heading';
import Subheading from 'components/common/Subheading';
import { HOME_CHEF } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import useFunnelMealPlan from 'hooks/useFunnelMealPlan';

import { mealCardHeading } from './mealCardData';
import MealCardSlider from './MealCardSlider';

const MenuGallery = () => {
  const mealPlanSlug = useFunnelMealPlan();
  const isHomeChef = useBrand(HOME_CHEF);

  return (
    <section
      className={cn('mt-4 bp1:-mb-6 bp2:mt-16', {
        'bg-cream-110': isHomeChef,
        'bg-white-100 pb-12 ': !isHomeChef,
      })}
    >
      <Heading
        className={cn(
          'text-md px-4 pt-4 font-lemondecourrier font-semibold leading-8 bp1:text-center bp1:text-2xl',
          {
            'text-green-110': isHomeChef,
            'text-tempo-blue-90': !isHomeChef,
          }
        )}
      >
        {mealCardHeading[mealPlanSlug]}
      </Heading>
      <Subheading
        brandStylesOverrides="text"
        className="text-md text px-4 pb-4 pt-2 font-normal leading-tight text-charcoal-100 bp1:text-center bp2:px-0"
      >
        Our menus rotate weekly. Get a sneak peek to see what we're cooking up!
      </Subheading>
      <MealCardSlider />
    </section>
  );
};

export default MenuGallery;
